module.exports = __webpack_public_path__ + "img/ethermoon.94e20da0.jpg";